import colors from 'Styles/colors';

// eslint-disable-next-line import/prefer-default-export
export const STEP_VALUES = [
  { value: 0, label: 'UNCLASSIFIED', parsedSeverity: 'unclassified', color: colors.grey89 },
  { value: 1, label: 'INFORMATIONAL', parsedSeverity: 'info', color: colors.blue9 },
  { value: 2, label: 'LOW', parsedSeverity: 'low', color: colors.green9 },
  { value: 3, label: 'MEDIUM', parsedSeverity: 'med', color: colors.orange5 },
  { value: 4, label: 'HIGH', parsedSeverity: 'high', color: colors.red6 },
  { value: 5, label: 'CRITICAL', parsedSeverity: 'critical', color: colors.purple7 }
];
